<template>
    <div class="retr__content">
        <div v-for="(group, idx) in retr.list" :key="`group-${idx}`" class="retr__rows-group">
            <template v-if="group.rows">
                <div v-for="(row, idxx) in group.rows" :key="`row-${idxx}`" class="retr__row">
                    <table-row
                        :name="row.name"
                        :value="row.value"
                        :percent="row.percent"
                        :bold="row.bold"
                    />
                </div>
            </template>

            <template v-else>
                <table-row
                    :name="group.name"
                    :value="group.is_percent ? group.value * 100 : group.value "
                    :percent="group.percent"
                    :bold="group.bold"
                    :percent-value="group.is_percent"
                />
            </template>
        </div>
    </div>
</template>

<script>
import retrMixin from './retr.mixin.js'

export default {
    mixins: [retrMixin]
}
</script>
